import { opaccAjaxPlugin } from '../opacc.static.js';
import { OpaccBasket } from './opacc.class.basket.js';

/** @module basket */

/**
 * Versandoptionen im Checkout bereitstellen und überprüfen
 *
 * @extends {OpaccBasket}
 */
export class OpaccBasketShipping extends OpaccBasket {
	constructor() {
		super();
		this.basketShippingAmountSelector = '[data-op-asyncbasket="shippingTotalAmount"]';
		this.attachEventListener();
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		if (this.wrapperElement) {
			this.wrapperElement.addEventListener('click', e => {
				// get selected Option
				let button = e.target.closest('.opc-shipping-infos .opc-radio > label');
				if(button) {
					let parent = button.closest('.opc-shipping-infos');
					let targetId = parent.closest('.delivery-selection').dataset.opHref;
					let allOptions = parent.querySelectorAll('input');
					let selectedOption = button.parentNode.querySelector('input');
					Array.from(allOptions).forEach(item => {
						item.removeAttribute('checked');
					});
					if(selectedOption) {
						selectedOption.setAttribute('checked', 'checked');
						let data = {
							type: 'basket',
							action: 'shipping',
							shippingNo: selectedOption.value,
							pluginId: 'deliveryType'
						};

                        let url = opaccAjaxPlugin.setAsyncUrl();
						opaccAjaxPlugin.fetchAsynPostForm(url, data, this.refreshContent.bind(this, targetId), this.asyncErrorHandler.bind(this), true);
					}
				}
			}, false);
		}
	}
}